<script>
  import Modal from "@components/Modal.svelte";
  import { Button, TextArea, TextInput } from "paxray-components-svelte";

  export let open = false;
  // { heading, subject, message } with the resource link already filled in
  export let invitation = null;

  let subject = "";
  let message = "";
  let copiedField = null;
  let filled = false;

  // Start from the suggestion every time the modal opens, earlier edits are dropped
  $: if (!open) filled = false;
  $: if (open && !filled && invitation) {
    subject = invitation.subject;
    message = invitation.message;
    copiedField = null;
    filled = true;
  }

  function copyTextFallback(text) {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  }

  async function copyText(text, field) {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        copyTextFallback(text);
      }
    } catch (error) {
      try {
        copyTextFallback(text);
      } catch (fallbackError) {
        console.error("Copy failed", fallbackError);
        return;
      }
    }

    copiedField = field;
    setTimeout(() => {
      if (copiedField === field) copiedField = null;
    }, 2000);
  }
</script>

<Modal
  bind:open
  modalHeading={invitation?.heading ?? ""}
  tooltipText={"A suggested message you can send to your participants.\nAdjust it here and copy it into your email."}
  modalClass="invitation-modal"
  autowidth
>
  <div class="invitation_fields">
    <TextInput
      labelText="Subject"
      tooltipText="Use this as the subject line of your email."
      bind:value={subject}
    />
    <TextArea
      labelText="Message"
      tooltipText={"Paste this text into your email.\nYou can change it here first, for example to add a deadline or a contact person."}
      rows={12}
      bind:value={message}
    />
  </div>
  <svelte:fragment slot="left-buttons">
    <Button
      kind="outline-dark"
      size="field"
      iconLeft={false}
      text="Close"
      on:click={() => (open = false)}
    />
    <div class="copy_buttons">
      <Button
        kind="secondary"
        size="field"
        iconLeft={false}
        text={copiedField === "subject" ? "Copied" : "Copy Subject"}
        on:click={() => copyText(subject, "subject")}
      />
      <Button
        kind="secondary"
        size="field"
        iconLeft={false}
        text={copiedField === "message" ? "Copied" : "Copy Message"}
        on:click={() => copyText(message, "message")}
      />
    </div>
  </svelte:fragment>
</Modal>

<style>
  :global(.custom-modal.invitation-modal .bx--modal-container) {
    width: 40rem;
    max-width: calc(100vw - 2rem);
  }

  /* All buttons live in the left slot, the empty action area would only add a gap on the right */
  :global(.custom-modal.invitation-modal .actions-buttons-container) {
    display: none;
  }

  .copy_buttons {
    display: flex;
    flex: 1;
    justify-content: flex-end;
    gap: 9px;
  }

  .invitation_fields {
    display: flex;
    flex-direction: column;
    gap: var(--control-gap);
  }
</style>
